import { render, staticRenderFns } from "./WidgetRecentNotifications.vue?vue&type=template&id=42b948b3"
import script from "./WidgetRecentNotifications.vue?vue&type=script&lang=js"
export * from "./WidgetRecentNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports